import axios from 'axios';
import Tooltip from 'rc-tooltip';
import React, { useEffect, useState , useRef } from 'react'
import { Helmet } from 'react-helmet';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { Link , useNavigate, useParams } from 'react-router-dom';
import { Button, Checkbox, InputWrapper, CustomSelect, Input , Textarea, Main, PageHeader, SegmentedControl, Container } from '../../../Components';
import { componentStatus, incidentStatus } from '../../../Constants/Constants';
import { calculateComponentGroupStatus } from '../../../Helpers/status';
import { useConfirmationModal } from '../../../Hooks/useNotifications';
import { ReactComponent as OperationalIcon } from './../../../assets/icons/component_status_operational.svg';
import {AiOutlineMinusSquare , AiOutlinePlusSquare} from 'react-icons/ai'

import './../incidents.css'

export function NewIncident() {


	const { page_id } = useParams();
	const navigate = useNavigate();
    const { user , org } = useSelector((state) => state.auth)
    const { getConfirmation } = useConfirmationModal();
	const effectCalled = useRef(false)
	const [formData, setFormData] = useState({
		name: "",
		description: "",
		descriptionPlaceholder : "We are currently investigating this issue.",
		status : "INVESTIGATING",
        notify_subscribers : false
	});
	const [formValidation, setFormValidation] = useState({
		name : "",
		description : "",
		components : "",
	})

	const [isLoadingComponents, setIsLoadingComponents] = useState(true)
	const [isLoading, setIsLoading] = useState(false)
	const [components, setComponents] = useState([])

	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
             // ! CHECK THE ACCESS 
            if(org?.statuspages?.findIndex(x => x.id === page_id) < 0 ) {
                navigate(`/pages`)
                return
            }
			await getComponents({
				page : 0,
				per_page : -1
			})
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])

	const onChangeStatus = (event) => {
	 
		const selectedStatus =  event.currentTarget.dataset.status
		const placeholder =  event.currentTarget.dataset.status_desc_placeholder
		setFormData( (prevState) => ({
			...prevState,
			status : selectedStatus,
			descriptionPlaceholder : placeholder,
			description : placeholder

		})) 

	}


	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	// const onChangeName = (e) => setFormData( prevState => ({ ...prevState , name : e.target.value }))
	const onChangeInputs = (e) => {
		switch(e.target.name){
			case "name" : 
				setFormValidation((prevState) => ({
					...prevState,
					name : (e.target.value === '') ? 'Invalid name' : ''
				}))
				
				break;
			
		}

        //console.log('e.target.value : ' , e.target.value)

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
		}));
	}

	/**
	 * 
	 * @param {*} e 
	 */
	const onChangeAffectedComponents = (e , _component_id) => {
		let _components = [...components]
		const index = _components.findIndex( x=> x.id === _component_id)
		_components[index].is_affected = e.target.checked
		setComponents(_components) 

		setFormValidation( prevState => ({
			...prevState ,
			components : _components.filter(x=>x.is_affected === true).length <= 0 ? "No component affected for this incident!" : ''
		}))
		
	}

	/**
	 * 
	 * @param {*} e 
	 * @param {*} _component_id 
	 */
	const onChangeAffectedComponentsStatus = (value , _component_id) => {
		let _components = [...components]
		const index = _components.findIndex( x=> x.id === _component_id)
		_components[index].component_status = value
		setComponents(_components) 

		 
		
	}
 

	/**
	 * 
	 * @param {*} param0 
	 * @returns 
	 */
	const getComponents = async ({ page , per_page}) => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingComponents(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = {
					page : page ,
					per_page : per_page,
					 
				}

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/components` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					 

					setComponents(data.data.map( item => ({
						id : item?.id,
						name : item?.name ,
						description : item?.description ,
						is_affected : false ,
						group_id : item?.group_id ,
						is_group : item?.is_group ,
						component_children : item?.component_children ,
						position : item?.position ,
						component_status : {
							value : "OPERATIONAL",
							label : 'Operational',
							icon : <OperationalIcon fill="white" color="#2fcc66"/>,
						}
					})))

					setIsLoadingComponents(false)
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/signout')
					}
					setIsLoadingComponents(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setComponents([])
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. Thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingComponents(false)
			}

		})
	}


	const selectAllComponents = () => {
		
		let _components = [...components]
		_components = _components.map( item => ({...item, is_affected : true }))
		setComponents(_components)
		
		setFormValidation( prevState => ({
			...prevState ,
			components : _components.filter(x=>x.is_affected === true).length <= 0 ? "No component affected for this incident!" : ''
		}))
	}

	const deselectAllComponents = () => {
		
		let _components = [...components]
		_components = _components.map( item => ({...item, is_affected : false }))
		setComponents(_components) 

		setFormValidation( prevState => ({
			...prevState ,
			components : _components.filter(x=>x.is_affected === true).length <= 0 ? "No component affected for this incident!" : ''
		}))
	}

	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading(true)
			const affectedComponents = components.filter(x => x.is_affected === true)
			setFormValidation((prevState) => ({
				...prevState,
				name: (formData.name === '') ? "Name can't be blank." : '',
				components : affectedComponents?.length <=0 ? "No component affected for this incident!" : ''
			}))

			if(formValidation.name !=='' || affectedComponents?.length <= 0 ){

				toast.error("Please complete all required fields") 
				setIsLoading(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { 
					name : formData?.name,
					description : formData?.description,
					components : components.filter( x=> x.is_affected === true).map( (prevElement) => ({
						...prevElement , 
						component_status : prevElement?.component_status?.value
					})),
					status : formData?.status,
                    notify_subscribers : formData?.notify_subscribers
				}

				const token = user?.token;


				await axios.post(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading(false)

					toast.success('Your component has been successfully created') 
					navigate(`/pages/${page_id}/incidents/${data?.incident?.id}/edit`)

					 
		
					resolve(data.data) 
		
				})
				.catch(error => {



                    let __error = "Something went wrong. thank you try later.";
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
                            __error = "Something went wrong. thank you try later.";
						}
					}

					toast.error(__error)  
                    reject(__error)  
				})
			}else{
				setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})

	}


    /** COMPONENT */
	const AffectedComponents = ({ }) => {
        //console.log(components);
		return (
			isLoadingComponents === true 
				? 'Loading ... '//<SkeletonAffectedComponent />
				: (
					components?.length <=0 
					? <div>
						<div className="noitems_title">No components to display</div>
						<div className="noitems_subtitle">The components of your website or application are the parts that allow it to function correctly. You can add some components here to view them.</div>
						<Link 
							className={`btn btn-purple`}
							to={`/pages/${page_id}/components/new`}
							>Add component</Link>
					</div>
					: <>
						{
							[...(components ?? [])].filter(x => x.is_affected === true ).length  === [...(components ?? [])].length 
								? <Button link={true} onClick={deselectAllComponents}>Select none</Button>	
								: <Button link={true} onClick={selectAllComponents}>Select all</Button>	
						}	
						{
							renderComponents({
								id: 'root',
								name: null,
								is_group: false,
								children: components.filter(x => x.group_id === null)
							})
						}
					</>
				)
		)
	}

	const AffectedComponentItem = ({ list , level , children  }) => {

		const [isOpen, setIsOpen] = useState(true)

		const groupStatus = calculateComponentGroupStatus(list?.children)
		const componentGroupStatusContent = componentStatus?.find( x => x.value === groupStatus )

		return (
			<div className={`${level === 0 ? 'component-items' : 'components-group'}`} >
				 
				{
					list.id !=='root' && 
					<div className='component-item'  onClick={() => setIsOpen(!isOpen)} >
						<div className="component-wrapper">
							<div className="component-group-icon" >
								{ isOpen === true 
									? <AiOutlineMinusSquare />
									: <AiOutlinePlusSquare />
								}
							</div>
							<div className="component-name">{list?.name}</div>
							<div className={`component-status ${componentGroupStatusContent?.color_name}`}>{componentGroupStatusContent?.label}</div>   
				
						</div>
					</div>
				}
				<div className={`children ${isOpen === true  ? 'opened' : ''}`}>
					{ children  }
				</div>
			</div>

		)
	}

	const renderComponents = (list , level = 0 ) => {

		const groupStatus = calculateComponentGroupStatus(list?.children)
		const componentGroupStatusContent = componentStatus?.find( x => x.value === groupStatus )
        //console.log(list)
	
		return (
			<AffectedComponentItem 
				list={list}
				level={level}
				>
					{
						list?.children?.map( ( component , index) => {

						 

							const componentStatusContent = componentStatus?.find( x => x.value === component?.status )
							return (
								component.is_group === false 
								? <div key={index} className="component-item ">
									<div className="component-wrapper">
										<div className='component-info'>
											<Checkbox 
												label={component?.name}
												checked={component?.is_affected}
												onChange={(e) => onChangeAffectedComponents(e , component?.id)}
											/>
											<div className='component-desc'>{component?.description?.length > 70 ? component?.description?.substr(0 , 75)+'...' : component?.description}</div>												
										</div>
										<div className='component-status'>
											<div className='component-status-wrapper'>
												{
													component?.is_affected === true && 
													<CustomSelect
                                                        data={
                                                            componentStatus?.map( item => ({
                                                                value : item?.value ,
                                                                label : item?.label ,
                                                                icon : item?.icon
                                                            }))
                                                        }
                                                        onChange={(value) => onChangeAffectedComponentsStatus(value , component?.id)}
                                                        name={`afcomp-${component?.id}`}
                                                        value={componentStatus.find( x => x.value === component?.component_status?.value)}
                                                        className="fluid"
                                                        showIcons={true}
                                                        isSearchable={false}
                                                            
                                                    />
													
												}
											</div>
										</div>
									</div>											
								</div>											
								: (
									renderComponents({
										id : component?.id ,
										name : component?.name ,
										is_group : component?.is_group,
										children : components?.filter( x => component?.component_children?.includes(x?.id))
									} , level +1)
								)
							)
						})
					}
				</AffectedComponentItem>
		)
	
	}
	
	const incidentStatusList = incidentStatus;
	const selectedStatus_indice = incidentStatusList.findIndex(x => x.id === formData.status) 

 
	

	return (
		<>
        <Helmet>
            <title>{`Add an incident - ${process.env.REACT_APP_APP_NAME}`}</title>
        </Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Status Pages', link: '/pages' },
				{ name: 'Incidents', link: `/pages/${page_id}/incidents` },
			]}
			 >
			<PageHeader
				title="Add an incident"
				// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
				/>
			<form className='incident-form incident-form_edit-grid'>

				<Input
					fluid
					name='name'
					placeholder=""
					label="Incident name"
					required
					mb={15}
					onChange={onChangeInputs}
					error={formValidation.name}
					value={formData.name}
					/>
				<div className="field-group fluid event-progress-wrapper" mt={15}>
					<label htmlFor="" className="fluid">Incident status *</label>
					<div className="outer-wrapper">
						<div id="event-progress-bar">
							<div className="padding"></div>
							<div className="progress-bar">
								<span className={`progress ${formData.status.toLowerCase()}`} ></span>
							</div>
							<div className="padding"></div>
						</div>
						<div className="events">
							{
								incidentStatusList.map( (incidentStatus , index) => { 
									let isActive = index <= selectedStatus_indice  ? true: false  ;
									


									return (	
										<div 
											key={index} 
											className={`event-wrapper ${incidentStatus.name.toLowerCase()}`}  
											data-status={incidentStatus.id} 
											data-status_desc_placeholder={incidentStatus?.placeholder}
											onClick={onChangeStatus}  >
												<div className="indicator">
													<div className={`dot ${isActive === true ? 'active' : ''} ${formData.status === incidentStatus.id ? 'selected' : ''}`}></div>
												</div>
												<div className={`label ${isActive === true ? 'active' : ''} ${formData.status === incidentStatus.id ? 'selected' : ''}`}>
													<span>{incidentStatus.name}</span>
												</div>
										</div>
										)
								})
							}
						</div>
					</div>
				</div>
				<Textarea
					fluid
					mt={15}
					placeholder={formData?.descriptionPlaceholder}
					value={formData?.description}
					label="Description"
					autosize
					rows={4}
					name="description"
					onChange={onChangeInputs}
				/>	
                <InputWrapper mt={15}
					fluid
					label="Notifications"
					
				>
                    <Checkbox
                        name="notify_subscribers"
                        label="Send notifications to the status page's subscribers"
                        value={formData?.notify_subscribers}
                        onChange={onChangeInputs}
                        />
                </InputWrapper>
				<InputWrapper mt={15}
					fluid
					label="Affected components"
					description="The components that are currently affected or were previously affected by this incident"
					error={formValidation?.components}
					required
				>
                   <AffectedComponents />
					{/* {
						isLoadingComponents === true 
						? 'loading ... '//<SkeletonAffectedComponent />
						: (
							components?.length <=0 
							? <div>
								<div className="noitems_title">No components to display</div>
								<div className="noitems_subtitle">The components of your website or application are the parts that allow it to function correctly. You can add some components here to view them.</div>
								<Link 
									className={`btn btn-purple`}
									to={`/pages/${page_id}/components/new`}
									>Add component</Link>
							</div>
							: <>
								{
									[...components].filter(x => x.is_affected === true ).length  === [...components].length 
									? <Button link={true} onClick={deselectAllComponents}>Select none</Button>	
									: <Button link={true} onClick={selectAllComponents}>Select all</Button>	

								}
								<ul className='incident-form_component-list'>
									{
										components.map( (component , index) => {
											return (
												<li key={index}>
													<div className='component-wrapper' >
														<div className='component-info'>
															<Checkbox 
																label={component?.name}
																checked={component?.is_affected}
																onChange={(e) => onChangeAffectedComponents(e , component?.id)}
															/>
															<div className='component-desc'>{component?.description?.length > 70 ? component?.description?.substr(0 , 75)+'...' : component?.description}</div>												
														</div>
														<div className='component-status'>
															<div className='component-status-wrapper'>
																{
																	component?.is_affected === true && 
																	<CustomSelect
																		data={
																			componentStatus?.map( item => ({
																				value : item?.value ,
																				label : item?.label ,
																				icon : item?.icon
																			}))
																		}
																		onChange={(value) => onChangeAffectedComponentsStatus(value , component?.id)}
																		name={`afcomp-${component?.id}`}
																		value={componentStatus.find( x => x.value === component?.component_status?.value)}
																		className="fluid"
																		showIcons={true}
																		isSearchable={false}
																		 
																	/>
																	
																}
															</div>
														</div>
													</div>

												</li>
											)
										})
									}
								</ul>
							</>
						)
						
						
						
					} */}
				</InputWrapper>
				 
			</form>		
			<div className="incident-form_footer-wrapper form_fixed_footer">
				<Container className="flex-end">
					<div   className='incident-form_footer'   >
						<Button color="gray" variant="default" >Back</Button>
						<Button onClick={onSubmit}  loading={isLoading}>{'Save incident'}</Button>
					</div>

				</Container>
			</div>
		</Main>
		</>
					
	)
}
